import React from "react"
import { styled } from "themes"
import { Input } from "antd"

export const StyledInput = styled((props: any) => <Input {...props} />)``
